import type { JSX } from 'react';

import { ErrorMessage } from 'formik';

import styles from './ErrorMessageLabel.module.css';

type ErrorMessageLabelProps = {
  name: string;
  component?: string;
};

export default function ErrorMessageLabel({
  name,
  component = 'span',
}: ErrorMessageLabelProps): JSX.Element {
  return (
    <ErrorMessage
      name={name}
      component={component}
      className={styles.ErrorMessage}
    />
  );
}
